import React, { Component } from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid } from '@material-ui/core';
import 'moment/locale/es'
import styles from './styles';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import AvailabilityObjectives from './AvailabilityObjectives';
import AvailabilityConsolidated from './AvailabilityConsolidated';
import 'react-vertical-timeline-component/style.min.css';
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

class PanelAvailability extends Component {

    constructor(props) {
        super(props)
        this.myCallback = this.myCallback.bind(this);
        //console.log('props',props)
        //console.log(groups)
        this.state = {
            isLoading:true,
            isLoadingConsolidated:true,
            groups:this.props.groups,
            names:this.props.nameGroup,
            dataError:false,
            maxObjs:this.props.maxObjs,
            newList:[],
            expandedPanels: {},
        }
    }
    myCallback = (dataFromChild) => {
        const {groups, newList, maxObjs}=this.state
        this.setState({ 
            newList:[...this.state.newList, dataFromChild],
            //isLoading:false
          })
        //console.log("medicion listas para proceesing", newList.length, maxObjs)
        if(newList.length+1===maxObjs){
            //console.log('va a process')
            this.processData();
        }
    }

    componentDidMount() {
        this.processData();
    }
    processData=(value)=>{
        const {newList, maxObjs, groups}=this.state
        //console.log(newList, maxObjs)
        if(newList.length===maxObjs){
            //console.log('carga consolidado')
            this.setState({ 
                isLoadingConsolidated:false,
            })
        }
        this.setState({ 
            isLoading:false,
        })
    }
    
    getObjectives=(group)=>{
        //console.log(group)
        var newGroup=(Object.keys(group).filter(i=>Number.isInteger(parseInt(i))===true).map( i=> group[i]))
        var newList=[]
        Object.keys(newGroup).map(obj=>{
                
            var incident=<Grid key={newGroup[obj].id} item lg={12} xl={12} >
                            < AvailabilityObjectives  obj={newGroup[obj]} callbackFromParent={this.myCallback}/>
                        </Grid>
            newList.push(incident)
        })
        
        
        return newList
    }

    consolidatedData=(groups)=>{
        
        const {isLoadingConsolidated, newList}=this.state
        const {classes}=this.props
        
        //console.log('consolidated', isLoadingConsolidated)
        var Consolidated=<Grid item lg={12} xl={12}>
                            <Typography
                            className={classes.circular}
                                variant="caption"
                                >
                                <CircularProgress
                                className={classes.circular}
                                variant="indeterminate"
                                size={8}
                                thickness={1}
                                
                                />
                                Cargando Consolidado
                            </Typography>
                        </Grid>

        if (isLoadingConsolidated===false) {
            var newGroup=(Object.keys(groups).filter(i=>Number.isInteger(parseInt(i))===true).map( i=> groups[i]))
            
            var objGroups=[]
            newGroup.map(objGroup=>{
                //console.log(objGroup)
                newList.map(obj=>{
                    if(parseInt(objGroup.id)===obj.obj.Objetivo_Id){
                        objGroup["data"]=obj
                        //console.log(obj)
                    }
                })
                if(objGroup.hasOwnProperty("data")===true){
                    objGroups.push(objGroup)
                }
            })
            //console.log('out', objGroups)
            Consolidated=<AvailabilityConsolidated objs={objGroups}/>
        }
        
        return Consolidated
    }
    
    togglePanelExpansion = panelId => {
        this.setState(prevState => ({
            expandedPanels: {
                ...prevState.expandedPanels,
                [panelId]: !prevState.expandedPanels[panelId],
            },
        }));
    }

    render() {
        //console.log('render panel')
        const {isLoading, groups, expandedPanels}=this.state
        const {classes}=this.props
        
        if (isLoading===true) {
            return(
                <Grid 
                container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.contentCircular}>
                    <Grid item lg={12} xl={12}>
                        <Typography
                        className={classes.circular}
                            variant="caption"
                            >
                            <CircularProgress
                            className={classes.circular}
                            variant="indeterminate"
                            size={8}
                            thickness={1}
                            
                            />
                            Cargando Grupos...
                        </Typography>
                    </Grid>
                </Grid>
            )
        }else{
            //console.log(groups)
            return(
                    <Grid item lg={6} xl={6} >
                        {Object.keys(groups).map(ele=>(
                            <ExpansionPanel
                                key={ele}
                                style={{borderTop: "outset"}}
                                onClick={this.handleClickChangeIcon}
                                expanded={expandedPanels[ele]}
                                onChange={() => this.togglePanelExpansion(ele)}
                            >
                                <ExpansionPanelSummary
                                classes={{
                                    content: classes.expansionPanelSummaryContent,
                                  }}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                                >
                                    <Grid 
                                        container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <Grid item lg={12} xl={12}>
                                            <Grid 
                                                container
                                                direction="row"
                                                justify="flex-start"
                                                alignItems="center"
                                            >
                                                <Grid item lg={6} xl={6}>
                                                    {expandedPanels[ele] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                </Grid>
                                                <Grid item lg={6} xl={6}>
                                                    <Typography>    
                                                        {groups[ele].titulo_grupo}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {this.consolidatedData(groups[ele])}
                                    </Grid>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Grid 
                                        container
                                        direction="row"
                                        justify="center"
                                        alignItems="flex-start"
                                        style={{display:"inline"}}
                                    >
                                        {this.getObjectives(groups[ele])}
                                    </Grid>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        ))}
                        
                    </Grid>
                
            )
        }
   
    }
}
export default
    compose(withStyles(styles))(PanelAvailability);